import React, { useEffect, useState } from 'react';
import { TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomTextField from '../components/customTextField';

export default function EditFasilitas(props) {

    const [id, setID] = useState("")
    const [nama, setNama] = useState("")
    const [lokasi, setLokasi] = useState("")
    const [kodeAntrian, setKodeAntrian] = useState("")
    const [catatan, setCatatan] = useState("")
    const [lokasiEksternal, setLokasiEksternal] = useState("")
    const [dataKategori, setDataKategori] = useState([])
    const [dataEksternal, setDataEksternal] = useState([])
    const [kategori, setKategori] = useState(null)
    const [eksternal, setEksternal] = useState(null)
    const [dataGedung, setDataGedung] = useState([])
    const [gedung, setGedung] = useState(null)
    const [lantai, setLantai] = useState("")
    const [is_default] = useState([
        { value: 'Ya', id: 1 },
        { value: 'Tidak', id: 0 },
    ])
    const [tipeRegis] = useState([
        { name: 'Umum', id: 1 },
        { name: 'Jaminan', id: 2 },
        { name: 'BPJS', id: 3 },
    ])
    const [pickTipe, setPickTipe] = useState([])
    const [pickDefault, setPickDefault] = useState(null)
    const [pickNonStop, setPickNonstop] = useState(null)
    const [errorName, setErrorName] = React.useState(false)
    const [errorLantai, setErrorLantai] = React.useState(false)
    const [errorBuilding, setErrorBuilding] = React.useState(false)
    const [errorKategori, setErrorKategori] = React.useState(false)
    const [texterrorKategori, setTextErrorKategori] = React.useState(null)
    const [texterrorname, setTextErrorName] = React.useState(null)
    const [texterrorLantai, setTextErrorLantai] = React.useState(null)
    const [texterrorBuilding, setTextErrorBuilding] = React.useState(null)

    useEffect(() => {
        getDataFacility()
    }, [])

    const getDataFacility = () => {
        api.create().getDetailFacility(props.detail[7]).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    console.log(response);
                    setID(data.id)
                    setNama(data.name)
                    setLantai(data.floor)
                    setLokasi(data.location)
                    setKodeAntrian(data.queue_code === null ? "" : data.queue_code)
                    setCatatan(data.notes === null ? "" : data.notes)
                    setLokasiEksternal(data.external_code === null ? "" : data.external_code)
                    getDataFacilityCategory(data.facility_category_id)
                    getDataGedung(data.building_id)
                    let indexID = is_default.findIndex((val) => val.id === data.is_default)
                    setPickDefault(is_default[indexID])
                    let indexNonstop = is_default.findIndex((val) => val.id === data.is_nonstop)
                    console.log(indexNonstop);
                    setPickNonstop(is_default[indexNonstop])
                    let pickReg = []
                    if (data.registration_type && data.registration_type.length > 0) {
                        data.registration_type.map((item) => {
                            let idxReg = tipeRegis.findIndex((val) => String(val.id) === item)
                            if (idxReg > -1) {
                                pickReg.push(tipeRegis[idxReg])
                            }
                        })
                    }
                    setPickTipe(pickReg)
                    forceUpdate()
                }
            }
        })
    }

    const getDataFacilityCategory = (id) => {
        api.create().getFacilityCategory().then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    let dataKategori = []
                    response.data.data.map(item => {
                        dataKategori.push({
                            id: item.id,
                            value: item.queue_type_in
                        })
                    })
                    let indexID = dataKategori.findIndex((val) => val.id === id)
                    setDataKategori(dataKategori)
                    setKategori(dataKategori[indexID])
                }
            }
        })
    }

    const getDataGedung = (id) => {
        api.create().getBuilding().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let dataGedung = []
                    response.data.data.map(item => {
                        if (item.deleted_at === null) {
                            dataGedung.push({
                                id: item.id,
                                value: item.name
                            })
                        }
                    })
                    let indexID = dataGedung.findIndex((val) => val.id === id)
                    setDataGedung(dataGedung)
                    setGedung(dataGedung[indexID])
                    forceUpdate()
                }
            }
        })
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleSave = () => {
        let tipeReg = []
        if (pickTipe.length > 0) {
            pickTipe.map((i) => {
                tipeReg.push(i.id)
            })
        }
        if (!nama) {
            setErrorName(true)
            setTextErrorName("Nama Fasilitas wajib diisi")
        } else if (!lantai) {
            setErrorLantai(true)
            setTextErrorLantai("Lantai wajib diisi")
        } else if (kategori === null) {
            setErrorKategori(true)
            setTextErrorKategori("Kategori wajib diisi")
        } else if (gedung === null) {
            setErrorBuilding(true)
            setTextErrorBuilding("Gedung wajib diisi")
        } else {
            let payload = {
                "id": id,
                "name": nama,
                "facility_category_id": kategori.id,
                "building_id": gedung.id,
                "floor": lantai,
                "queue_code": kodeAntrian,
                "notes": catatan,
                "external_code": lokasiEksternal === "" ? null : lokasiEksternal,
                "is_default": pickDefault.id,
                "is_nonstop": pickNonStop.id,
                "registration_type": tipeReg
            }
            props.editFacility(payload)
        }
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit Fasilitas</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <CustomTextField
                            required={true}
                            label={"Nama Fasilitas"}
                            error={errorName}
                            helperText={texterrorname}
                            value={nama}
                            onChange={(val) => {
                                setNama(val)
                                setErrorName(false)
                                setTextErrorName("")
                            }}
                        />

                        <Autocomplete
                            disableClearable
                            options={tipeRegis}
                            multiple
                            getOptionLabel={(option) => option.name}
                            onChange={(event, newInputValue) => {
                                setPickTipe(newInputValue)
                                forceUpdate()
                            }}
                            style={{ marginTop: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Opsi Pembayaran"
                                />
                            }
                            value={pickTipe}
                        />
                        <Autocomplete
                            options={dataGedung}
                            getOptionLabel={(option) => option.value}
                            name='gedung'
                            id="gedung"
                            onChange={(event, newInputValue) => {
                                setGedung(newInputValue)
                                setErrorBuilding(false)
                                setTextErrorBuilding("")
                                forceUpdate()
                            }}
                            style={{ marginTop: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Gedung"
                                    required={true}
                                    error={errorBuilding}
                                    helperText={texterrorBuilding}
                                />
                            }
                            value={gedung}
                        />
                        <div style={{ marginTop: 15 }}>
                            <CustomTextField
                                required={true}
                                label={"Lantai"}
                                error={errorLantai}
                                helperText={texterrorLantai}
                                value={lantai}
                                type="number"
                                onChange={(val) => {
                                    setLantai(val)
                                    setErrorLantai(false)
                                    setTextErrorLantai("")
                                }}
                            />
                        </div>
                        <Autocomplete
                            disableClearable
                            options={is_default}
                            getOptionLabel={(option) => option.value}
                            onChange={(event, newInputValue) => {
                                setPickNonstop(newInputValue)
                                forceUpdate()
                            }}
                            style={{ marginTop: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Non Stop"
                                />
                            }
                            value={pickNonStop}
                        />
                    </div>
                    <div className="column-2">
                        <Autocomplete
                            options={dataKategori}
                            getOptionLabel={(option) => option.value}
                            name='kategori'
                            id="kategori"
                            onChange={(event, newInputValue) => {
                                setKategori(newInputValue)
                                setErrorKategori(false)
                                setTextErrorKategori("")
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Kategori"
                                    required={true}
                                    error={errorKategori}
                                    helperText={texterrorKategori}
                                />
                            }
                            value={kategori}
                        />
                        {/* <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="queueCode"
                                name="queueCode"
                                label="Kode Antrian"
                                placeholder={"input Kode Antrian"}
                                onChange={(e) => {
                                    setKodeAntrian(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    maxLength: 2,
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={kodeAntrian}
                            />
                        </div> */}
                        <Autocomplete
                            options={is_default}
                            disableClearable
                            getOptionLabel={(option) => option.value}
                            onChange={(event, newInputValue) => {
                                setPickDefault(newInputValue)
                                forceUpdate()
                            }}
                            style={{ marginTop: 15 }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Default"
                                />
                            }
                            value={pickDefault}
                        />
                        <div style={{ marginTop: 15 }}>
                            <CustomTextField
                                label={"Catatan"}
                                value={catatan}
                                onChange={(val) => {
                                    setCatatan(val)
                                }}
                            />

                        </div>
                        <div style={{ marginTop: 15 }}>
                            <CustomTextField
                                label={"Lokasi Eksternal"}
                                value={lokasiEksternal}
                                onChange={(val) => {
                                    setLokasiEksternal(val)
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleSave()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}